<template>
    <div id="ql-app">
        <core-header :project="project" :user="user" :locked="isLocked"></core-header>
        <core-nav-main :project="project" :user="user"></core-nav-main>
        <md-layout md-flex="100" md-row md-gutter="12" class="sub-header">
            <project-header 
                :currentPage="currentPage" 
                :totalPages="totalPages" 
                :locked="isLocked" 
                :showMode="showMode"
                :isOwner="user.uid === project.ownerUID"
                :isActivePay="user.active_pay"
                @pageUp="pageUp" 
                @pageDown="pageDown"
                @setPage="setCurrentPage"
                @toggleShowMode="toggleShowMode"
                @toggleLocked="toggleLocked"/>
        </md-layout >
        <md-layout class="page-viewer"> <!--md-flex="100" md-row md-gutter="24"-->
            <project-pages 
                :pages="projectPages" 
                :currentPage="currentPage" 
                :currentUser="user"
                :locked="isLocked" 
                :showMode="showMode"/>
        </md-layout>
        <core-footer></core-footer>
    </div>
</template>

<script>
// Vendor Libraries
import Vue from 'vue';
import PDFJS from 'pdfjs-dist/webpack';
import firebase from 'firebase';
import { mapGetters } from 'vuex';
// Buses
import NavBus from '@/buses/nav';
// App Components
import CoreNavMain from '@/components/core/nav/main';
import CoreHeader from '@/components/core/header';
import CoreFooter from '@/components/core/footer';
import ProjectHeader from '@/components/project/header';
import ProjectPages from '@/components/project/pages';
// TESTING

PDFJS.workerSrc = '../../../node_modules/pdfjs-dist/build/pdf.worker.js';

const ProjectView = {
    name: 'project',
    props: ['id', 'version'],
    data: function() {
        return {
            projectRef: firebase.database().ref(`projects/${this.id}`),
            currentPage: 1,
            pdfPages: [],
            projectPages: [],
            theme: 'default'
        };
    },
    computed: {
        ...mapGetters([
            'project',
            'documentUrl',
            'isLocked',
            'user',
            'showMode'
        ]),
        totalPages() {
            return this.pdfPages.length;
        }
    },
    watch: {
        project: function() {
            if (this.project) {
                this.initDocument();
            }
        },
        version: function() {
            if (this.version) {
                this.$store.dispatch('useVersion', this.version);
            } else {
                this.$store.dispatch('useVersion', null);
            }
        }
    },
    methods: {
        toggleShowMode() {
            // this.showMode = !this.showMode;
            this.$store.dispatch('updateShowMode', !this.showMode);
            if (this.showMode) {
                this.theme = 'show-mode';
            } else {
                this.theme = 'default';
            }
            Vue.material.setCurrentTheme(this.theme);
        },
        toggleLocked() {
            this.$store.dispatch('lockProject', !this.isLocked);
        },
        setCurrentPage(number) {
            this.currentPage = number;
        },
        pageUp() {
            this.currentPage++;
        },
        pageDown() {
            this.currentPage--;
        },
        initDocument: function() {
            if (this.documentUrl) {
                console.log('Initializing Document');
                this.loadDocument(this.documentUrl).then((pdfDoc) => {
                    const pdfPageProms = [];
                    this.pdfDoc = pdfDoc;
                    this.docLoaded = true;

                    for (let i = 1; i < pdfDoc.numPages + 1; i++) {
                        const prom = pdfDoc.getPage(i);
                        pdfPageProms.push(prom);
                    }

                    Promise.all(pdfPageProms).then((pdfPages) => {
                        this.pdfPages = pdfPages;
                        this.projectPages = [];

                        pdfPages.forEach((page, index) => {
                            const newPage = {
                                pageNumber: index + 1,
                                pdfPage: page
                            };
                            this.projectPages.push(newPage);
                        });
                    });
                });
            } else {
                console.error('Could not init document');
            }
        },
        loadDocument: function(documentSrc) {
            this.pdfDoc = null;

            const loadingTask = PDFJS.getDocument(documentSrc);

            loadingTask.onProgress = (status) => {
                const ratio = status.loaded / status.total;
                this.loadingProgress = Math.min(ratio, 1);
            };

            return loadingTask;
        }
    },
    components: {
        'core-nav-main': CoreNavMain,
        'core-header': CoreHeader,
        'core-footer': CoreFooter,
        'project-header': ProjectHeader,
        'project-pages': ProjectPages
    },
    beforeRouteEnter: function(to, from, next) {
        next((vm) => {
            vm.$store.dispatch('setUsersRef', {
                ref: firebase.database().ref('users'),
                options: {}
            });
            vm.$store.dispatch('setActiveUser', {
                ref: firebase.database().ref(`users/${firebase.auth().currentUser.uid}`),
                options: { readyCallback: () => {} }
            });
            vm.$store.dispatch('setActiveProject', {
                ref: firebase.database().ref(`projects/${vm.id}`),
                options: { readyCallback: () => { 
                    console.log('project should be ready');
                } }
            });
        });
    },
    created: function() {
        if (this.version) {
            this.$store.dispatch('useVersion', this.version);
        } else {
            this.$store.dispatch('useVersion', null);
        }
        
        NavBus.$on('goToPage', (e) => {
            this.currentPage = e;
        });
    }
};

export default ProjectView;
</script>

<style lang="scss">
    #ql-app {
        // height: 100%;
        // display: flex;
        // flex-direction: column;
        .sub-header {
            // flex: 0 1 64px;
        }
    }
</style>


// WEBPACK FOOTER //
// project.vue?35105b68